export var ownershipTypes = [
    'D',
    'E',
    'G',
    'M',
    'F',
    'C',
    'EE',
    'I',
    'K',
    'L',
    'N',
    'NO',
    'O',
    'R',
];
//# sourceMappingURL=constants.js.map